/**
 * Deterministic name -> colour + initials, carried over from the previous
 * dashboard's UserAvatar. Deterministic matters: the same person keeps the
 * same colour across sessions and screens, which is what makes an avatar
 * scannable in a list.
 */
const PALETTE = [
  "#3456FF",
  "#087F7A",
  "#7A3E9D",
  "#B4541C",
  "#1F6FB2",
  "#8A1C4A",
  "#2F6B3A",
  "#5C4B8A",
];

export function avatarColor(seed: string): string {
  let hash = 0;
  for (let i = 0; i < seed.length; i++) {
    hash = (hash << 5) - hash + seed.charCodeAt(i);
    hash |= 0;
  }
  return PALETTE[Math.abs(hash) % PALETTE.length];
}

export function initials(firstName?: string, lastName?: string): string {
  const first = firstName?.trim()?.[0] ?? "";
  const last = lastName?.trim()?.[0] ?? "";
  return `${first}${last}`.toUpperCase() || "?";
}
